import CallLog from "@/interfaces/CallLog";

export function callActorLabel(
  row: Pick<
    CallLog,
    "actorAttribution" | "actorName" | "actorOrganisationName"
  >,
): string {
  if (row.actorAttribution === "unanswered") return "Non décroché";
  if (row.actorAttribution !== "verified" || !row.actorName)
    return "Compte non identifié";
  return [row.actorName, row.actorOrganisationName].filter(Boolean).join(" — ");
}
